import React, { useRef, useState } from "react";
import HelpIcon from "../../../../../assets/images/icons/HelpIcon";
import { CustomIconStyle } from "../../../../../assets/styles/Button";
import { SECTIONS } from "../../container/SectionsVideo.constants";
import VideoPlayerModal from "../VideoPlayerModal/VideoPlayerModal";
import { MenuOptionStyle } from "./MenuOption.style";
import useOutsideClick from "../../../../../hooks/useOutsideClick/useOutsideClick";
import { useTranslation } from "react-i18next";
import { CustomStyledIconButton } from "../../../../../styles/global.style";

const MenuOption = () => {
  const [open, setOpen] = useState(false);
  const [section, setSection] = useState<any>();
  const ref = useRef(null);

  const { t } = useTranslation();

  const closeVideoModal = () => {
    setSection(null);
  };

  useOutsideClick(ref, () => {
    setOpen(false);
  });

  return (
    <>
      <MenuOptionStyle ref={ref}>
        <CustomStyledIconButton onClick={() => setOpen(!open)}>
          <HelpIcon />
        </CustomStyledIconButton>
        {open && (
          <div className="wrapper">
            <div className="title">{t("MENU_OPTIONS.TITLE")}</div>
            <ul className="list">
              {SECTIONS.map((section, index) => (
                <li
                  className="item"
                  key={index}
                  onClick={() => {
                    setSection(section);
                    setOpen(false);
                  }}
                >
                  {t(`MENU_OPTIONS.${section.name}`)}
                </li>
              ))}
            </ul>
          </div>
        )}
      </MenuOptionStyle>
      <VideoPlayerModal section={section} setSection={setSection} />
    </>
  );
};

export default MenuOption;
